module.exports = __webpack_public_path__ + "img/head.2ef2a95f.webp";